"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var classnames_1 = __importDefault(require("classnames"));
var colors_1 = require("../../constants/colors");
var utils_1 = require("../../utils");
var AXSIcon_1 = __importDefault(require("../../elements/AXSIcon"));
var Table = styled_components_1.default.table(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-collapse: collapse;\n  display: table;\n  width: ", ";\n"], ["\n  border-collapse: collapse;\n  display: table;\n  width: ", ";\n"])), function (_a) {
    var tableWidth = _a.tableWidth;
    return tableWidth ? tableWidth : 'auto';
});
var Td = styled_components_1.default.td(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: ", ";\n  border-bottom: ", ";\n  color: ", ";\n  display: table-cell;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  padding: 16px;\n  text-align: left;\n  vertical-align: ", ";\n"], ["\n  background-color: ", ";\n  border-bottom: ", ";\n  color: ", ";\n  display: table-cell;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  padding: 16px;\n  text-align: left;\n  vertical-align: ", ";\n"])), function (_a) {
    var rowBackgroundColor = _a.rowBackgroundColor, theme = _a.theme;
    return utils_1.parseThemePath(rowBackgroundColor, theme, 'transparent');
}, function (_a) {
    var rowBorderColor = _a.rowBorderColor, theme = _a.theme;
    return "1px solid " + utils_1.parseThemePath(rowBorderColor, theme, colors_1.colors.GREY_300);
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return utils_1.parseThemePath(color, theme, colors_1.colors.GREY_450);
}, function (_a) {
    var verticalAlign = _a.verticalAlign;
    return verticalAlign || 'top';
});
var HeaderRow = styled_components_1.default.tr(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border-bottom: ", ";\n"], ["\n  border-bottom: ", ";\n"])), function (_a) {
    var headerBorderColor = _a.headerBorderColor, theme = _a.theme;
    return "1px solid " + utils_1.parseThemePath(headerBorderColor, theme, colors_1.colors.GREY_300);
});
var TableRow = styled_components_1.default.tr(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  background-color: ", ";\n  border-bottom: ", ";\n  cursor: ", ";\n  opacity: ", ";\n"], ["\n  background-color: ", ";\n  border-bottom: ", ";\n  cursor: ", ";\n  opacity: ", ";\n"])), function (_a) {
    var rowBackgroundColor = _a.rowBackgroundColor, theme = _a.theme;
    return "1px solid " + utils_1.parseThemePath(rowBackgroundColor, theme, colors_1.colors.GREY_50);
}, function (_a) {
    var rowBorderColor = _a.rowBorderColor, theme = _a.theme;
    return "1px solid " + utils_1.parseThemePath(rowBorderColor, theme, colors_1.colors.GREY_300);
}, function (_a) {
    var onClick = _a.onClick;
    return typeof onClick === 'function' ? 'pointer' : 'default';
}, function (_a) {
    var disabled = _a.disabled;
    return disabled ? '.3' : '1';
});
var Th = styled_components_1.default.th(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  background-color: ", ";\n  color: ", ";\n  cursor: ", ";\n  display: table-cell;\n  font-size: 12px;\n  font-weight: ", ";\n  letter-spacing: 1px;\n  line-height: 16px;\n  max-width: ", ";\n  min-width: ", ";\n  padding: 16px;\n  position: relative;\n  text-align: ", ";\n  text-transform: uppercase;\n  vertical-align: ", ";\n  width: ", ";\n\n  div {\n    display: inline-block;\n  }\n"], ["\n  background-color: ", ";\n  color: ", ";\n  cursor: ", ";\n  display: table-cell;\n  font-size: 12px;\n  font-weight: ", ";\n  letter-spacing: 1px;\n  line-height: 16px;\n  max-width: ", ";\n  min-width: ", ";\n  padding: 16px;\n  position: relative;\n  text-align: ", ";\n  text-transform: uppercase;\n  vertical-align: ", ";\n  width: ", ";\n\n  div {\n    display: inline-block;\n  }\n"])), function (_a) {
    var headerBackgroundColor = _a.headerBackgroundColor, theme = _a.theme;
    return utils_1.parseThemePath(headerBackgroundColor, theme, colors_1.colors.GREY_50);
}, function (_a) {
    var headerColor = _a.headerColor, theme = _a.theme;
    return utils_1.parseThemePath(headerColor, theme, colors_1.colors.GREY_450);
}, function (_a) {
    var sortable = _a.sortable;
    return sortable ? 'pointer' : 'default ';
}, function (_a) {
    var active = _a.active;
    return active ? 700 : 400;
}, function (_a) {
    var maxWidth = _a.maxWidth;
    return maxWidth ? maxWidth : 'auto';
}, function (_a) {
    var minWidth = _a.minWidth;
    return minWidth ? minWidth : 'auto';
}, function (_a) {
    var headerAlign = _a.headerAlign;
    return (headerAlign ? headerAlign : 'left');
}, function (_a) {
    var headerVerticalAlign = _a.headerVerticalAlign;
    return headerVerticalAlign || 'top';
}, function (_a) {
    var width = _a.width;
    return width ? width : 'auto';
});
var SortIcon = styled_components_1.default(AXSIcon_1.default)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: inline-block;\n  position: absolute;\n  top: 11px;\n"], ["\n  display: inline-block;\n  position: absolute;\n  top: 11px;\n"])));
var DefaultProps = {
    activeColumn: 0,
    color: 'axsui.components.table.color',
    headerBackgroundColor: 'axsui.components.table.headerBackgroundColor',
    headerBorderColor: 'axsui.components.table.headerBorderColor',
    headerColor: 'axsui.components.table.headerColor',
    rowBackgroundColor: 'axsui.components.table.rowBackgroundColor',
    rowBorderColor: 'axsui.components.table.rowBorderColor',
    sortDirection: 'asc',
    sortIconColor: 'axsui.components.table.sortIconColor',
    tableWidth: 'auto',
};
var getSortedColumns = function (columns, activeCol, sortDir) {
    return columns.sort(function (a, b) {
        var aString = a.data && a.data[activeCol] && a.data[activeCol].props ?
            a.data[activeCol].props.sortString : a.data && a.data[activeCol];
        var bString = b.data && b.data[activeCol] && b.data[activeCol].props ?
            b.data[activeCol].props.sortString : b.data && b.data[activeCol];
        return sortDir === 'dsc' ? aString < bString ? 1 : -1 : aString > bString ? 1 : -1;
    });
};
var AXSTable = function (_a) {
    var headerColumns = _a.headerColumns, headerColor = _a.headerColor, headerBorderColor = _a.headerBorderColor, headerBackgroundColor = _a.headerBackgroundColor, color = _a.color, columns = _a.columns, headerAlign = _a.headerAlign, rowBorderColor = _a.rowBorderColor, rowBackgroundColor = _a.rowBackgroundColor, verticalAlign = _a.verticalAlign, rowClickHandler = _a.rowClickHandler, headerVerticalAlign = _a.headerVerticalAlign, tableWidth = _a.tableWidth, sortDirection = _a.sortDirection, accessKey = _a.accessKey, cellPadding = _a.cellPadding, cellSpacing = _a.cellSpacing, activeColumn = _a.activeColumn, sortIconColor = _a.sortIconColor, sortable = _a.sortable, props = __rest(_a, ["headerColumns", "headerColor", "headerBorderColor", "headerBackgroundColor", "color", "columns", "headerAlign", "rowBorderColor", "rowBackgroundColor", "verticalAlign", "rowClickHandler", "headerVerticalAlign", "tableWidth", "sortDirection", "accessKey", "cellPadding", "cellSpacing", "activeColumn", "sortIconColor", "sortable"]);
    var _b = React.useState(activeColumn), activeCol = _b[0], setActiveCol = _b[1];
    var _c = React.useState(sortDirection), sortDir = _c[0], setSortDir = _c[1];
    var sortedColumns = sortable ? getSortedColumns(columns, activeCol, sortDir) : columns;
    return (React.createElement(Table, __assign({}, props, { tableWidth: tableWidth, className: classnames_1.default(['c-axs-table']) }),
        React.createElement("tbody", null,
            React.createElement(HeaderRow, { headerBorderColor: headerBorderColor }, headerColumns.map(function (column, index) { return (React.createElement(Th, { active: activeCol === index && column.sortable, id: column.id ? column.id : "header-col-" + index, headerAlign: headerAlign, headerBackgroundColor: headerBackgroundColor, headerBorderColor: headerBorderColor, headerColor: headerColor, key: "col-" + index, maxWidth: column.maxWidth, minWidth: column.minWidth, onClick: function () {
                    if (column.sortable) {
                        setSortDir(activeCol === index ? sortDir === 'asc' ? 'dsc' : 'asc' : 'asc');
                        setActiveCol(index);
                    }
                }, sortable: column.sortable, width: column.width },
                column.data,
                " ",
                activeCol === index && column.sortable ?
                    React.createElement(SortIcon, { color: sortIconColor, direction: sortDir, name: "keyboard-arrow-" + (sortDir === 'dsc' ? 'down' : 'up') }) : null)); })),
            sortedColumns.map(function (row, index) { return (React.createElement(TableRow, { disabled: row.disabled, onClick: typeof row.onClick === 'function' && row.disabled ? row.onClick : null, key: "r-" + index }, row.data.map(function (data, index) { return (React.createElement(Td, { color: color, key: index + "-d", rowBackgroundColor: rowBackgroundColor, rowBorderColor: rowBorderColor, verticalAlign: verticalAlign }, data)); }))); }))));
};
AXSTable.defaultProps = DefaultProps;
exports.default = AXSTable;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=index.js.map